import { AitRowData } from "./AitRowData";
import { AitHeaderRowData } from "./interface";

/**
 * Append cells from `append` rows onto the right-hand side of `base` rows.
 * Both arrays must have the same length; cells from `append[i]` are concatenated
 * to `base[i]`.
 *
 * @param base - Base rows which will receive appended cells
 * @param append - Rows providing cells to append to the base
 * @returns A new array of rows where each row's `cells` is the concatenation of
 *          the corresponding `base` and `append` cells.
 */
export const appendCells = <T, R extends AitRowData<T> | AitHeaderRowData<T>>(
  base: R[],
  append: R[],
): R[] => {
  return base.map((r, ri) => {
    return {
      aitid: r.aitid,
      cells: [...r.cells, ...append[ri].cells],
      coreTrafficLight: r.coreTrafficLight,
      templateAitId: r.templateAitId,
      annotation: r.annotation,
    } as R;
  });
};
